<template>
    <div class="profile-sidebar">
        <div class="avatar-con">
            <img class="img-responsive" :src="avatarImage">
            <button v-if="isAvatarImageDefault" class="btn btn-primary btn-photos" @click="$router.push({ name: 'user-photos' })">{{ 'Add Photo' | translate }}</button>
            <i v-if="isPremium && subscriptionAllowed" class="icon icon-ribbon-colored"></i>
            <i v-if="avatarIsPrivate" class="fa fa-unlock-alt"></i>
        </div>
        <div class="menu-con">
            <base-menu class="main-menu" :menu="main_menu"></base-menu>
        </div>
        <div class="vip-con">
            <h2 class="vip-title">
                <i v-if="subscriptionAllowed" class="icon icon-fire"></i>
                <span>{{ 'Vip Members' | translate }}</span>
            </h2>
            <div class="vip-member-list">
                <div v-for="profile in topProfiles" class="vip-member" @click="$router.push({ name: 'user-other-profile', params: { name: profile.nick_name } })">
                    <base-image class="vip-avatar" :image="profile.thumb_picture" :blur-image="withBlur && Boolean(profile.picture_is_blurred)" alt="avatar"></base-image>
                    <div class="vip-info">
                        <h5>{{profile.nick_name}}</h5>
                        <p><span>{{profile.age}} {{ 'yrs' | translate }}</span> {{profile.province_name}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!isPremium && subscriptionAllowed" class="ad-con">
            <adv-bannr @click.native="$router.push({ name: 'user-premium' })"></adv-bannr>
            <!-- <adv-bannr v-if="gender == 'male'" :banners="multiBannners" layout-type="multiple"></adv-bannr> -->
        </div>
    </div>
</template>

<script>
    import BaseMenu from '@views/common/BaseMenu'
    import BaseImage from '@views/common/BaseImage'
    import AdvBannr from '@views/user/partials/AdvBannr'
    import ProfileSidebar from '@views/user/partials/ProfileSidebar/profile_sidebar'

    export default {
        mixins: [ProfileSidebar],
        components: {
            BaseMenu,
            BaseImage,
            AdvBannr
        }
    }
</script>

<style lang="scss" src="./profile_sidebar.scss"></style>
